module.exports = __webpack_public_path__ + "/static/assets/0c8f529bb6607606374003ef056226d7.png";